import React, { useContext } from "react";
import "./ProjectDetails.css";
import { ProjectContext } from "../context/ProjectContext";
import { BASE_URL } from "../api/Api";

const DocumentsReports = () => {
  const { projectDetails, loadingProject } = useContext(ProjectContext);

  if (loadingProject || !projectDetails) {
    return <div>Loading Report Docs ...</div>;
  }

  const proposalDocs = projectDetails?.proposal_docs || [];
  const loaDocs = projectDetails?.loa_docs || [];
  const phasePhotos = projectDetails?.phase_photos || [];

  const hasDocuments =
    proposalDocs.length > 0 ||
    loaDocs.length > 0 ||
    phasePhotos.length > 0;

  return (
    <div className="card documents-card">
      <div className="card-body">
        <h5 className="mb-4 fw-semibold">Documents & Reports</h5>

        {!hasDocuments && (
          <div className="text-muted">
            No documents available for this project.
          </div>
        )}

        {/* 📄 PROPOSAL DOCS */}
        {proposalDocs.length > 0 && (
          <>
            <h6 className="mb-3">Proposal Documents</h6>

            {proposalDocs.map((doc, index) => (
              <div key={index} className="doc-row">
                <a
                  href={`${BASE_URL}/assets/docs/${doc}`}
                  target="_blank"
                  rel="noreferrer"
                  className="doc-link"
                >
                  <i className="bi bi-file-earmark-text doc-icon"></i>
                  <span className="ms-2">
                    Proposal Document {index + 1}
                  </span>
                </a>
              </div>
            ))}
          </>
        )}

        {/* 📄 LOA DOCS */}
        {loaDocs.length > 0 && (
          <>
            <h6 className="mb-3 mt-4">LOA Documents</h6>

            {loaDocs.map((doc, index) => (
              <div key={index} className="doc-row">
                <a
                  href={`${BASE_URL}/assets/docs/${doc}`}
                  target="_blank"
                  rel="noreferrer"
                  className="doc-link"
                >
                  <i className="bi bi-file-earmark-text doc-icon"></i>
                  <span className="ms-2">
                    LOA Document {index + 1}
                  </span>
                </a>
              </div>
            ))}
          </>
        )}

        {/* 🖼️ PHASE FILES */}
        {phasePhotos.length > 0 && (
          <>
            <h6 className="mt-4 mb-3">Phase Files</h6>

            {phasePhotos.map((file, index) => (
              <div key={index} className="doc-row">
                <a
                  href={`${BASE_URL}/assets/images/${file}`}
                  target="_blank"
                  rel="noreferrer"
                  className="doc-link"
                >
                  <i className="bi bi-file-earmark doc-icon"></i>
                  <span className="ms-2">
                    Phase File {index + 1}
                  </span>
                </a>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default DocumentsReports;    